export function getProductReviewId(row) {
  return row?.ProductReviewId ?? row?.productReviewId;
}

export function getProductId(row) {
  return row?.ProductId ?? row?.productId;
}

export function getUserId(row) {
  return row?.UserId ?? row?.userId;
}

export function formatReviewDate(value) {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-IN', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function truncateText(text, max = 80) {
  const str = String(text ?? '').trim();
  if (!str) return '—';
  return str.length > max ? `${str.slice(0, max)}…` : str;
}
